import { UpdatedMessageResponse } from "../entities/onUpdatedMessageSocket";
import { ChatSocketRepository } from "../repositories/ChatSocketRepository";

export class OnUpdateMessage {
	constructor(private repository: ChatSocketRepository) {}

	execute(callback: (data: UpdatedMessageResponse[]) => void): void {
		return this.repository.onUpdateMessage(callback);
	}
}
